export default __webpack_public_path__ + "static/media/edufy2.0e3bbb37.png";